// SearchResults — Presentational composition of the post-search result states:
// LoadingState, ErrorState, ResultsList/EmptyResults, and CollapsedMessage.
//
// Extracted VERBATIM from `components/RestaurantSearch.js` (behavior-preserving
// refactor, issue #240). Render-only, wrapped in React.memo. The
// `showResults`/`hasResults`/`showCollapsedMsg` conditionals and the render
// structure are identical to the source.
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';
import { LoadingState } from './LoadingState';
import { ErrorState } from './ErrorState';
import { ResultsList } from './ResultsList';
import { EmptyResults } from './EmptyResults';
import { CollapsedMessage } from './CollapsedMessage';

export const SearchResults = React.memo(function SearchResults({
  hasSearched, loading, error, restaurants, isCollapsed, setIsCollapsed,
  trip, userProfile, onReservationCreated
}) {
  const showResults = hasSearched && !loading && !error;
  const hasResults = restaurants.length > 0;
  const showCollapsedMsg = showResults && isCollapsed && hasResults;

  return (
    <>
      {loading && <LoadingState />}

      {error && <ErrorState error={error} />}

      {showResults && (
        <>
          {hasResults ? (
            <ResultsList
              restaurants={restaurants}
              isCollapsed={isCollapsed}
              setIsCollapsed={setIsCollapsed}
              trip={trip}
              userProfile={userProfile}
              onReservationCreated={onReservationCreated}
            />
          ) : (
            <EmptyResults />
          )}
        </>
      )}

      {showCollapsedMsg && <CollapsedMessage />}
    </>
  );
});

export default SearchResults;
